import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import errorReporter from 'web/utils/error-reporter';
import toReportableError from 'web/utils/reportableError';
import DashboardApp from './App/DashboardApp';

import 'web/utils/sw-cleanup';

const rootElement = document.getElementById('root');

createRoot(rootElement, {
  onRecoverableError: (error) => errorReporter.report(toReportableError(error)),
}).render(
  <BrowserRouter>
    <DashboardApp />
  </BrowserRouter>,
);
